import * as React from "react";
import Avatar from "react-avatar";
import { Button } from "reactstrap";
import { GetCurrentLoggedInUser, ROLE_CLAIM } from "../account/AccountStore";
import { GetAdmins, IdentityUser, RemoveClaim } from "../users/UserStore";

export const AdminsIndex = () => {
    const [admins, setAdmins] = React.useState([] as IdentityUser[]);

    React.useEffect(() => {
        GetCurrentLoggedInUser().then((response) => {
            if (response.claims.some((c) => c.type === ROLE_CLAIM && c.value === "SuperAdmin")) {
                GetAdmins().then((res) => {
                    setAdmins(res.data);
                });
            }
        });
    }, []);

    const removeAdminClaim = (userId) => () => {
        RemoveClaim(userId, ROLE_CLAIM, "Admin").then(() => {
            GetAdmins().then((res) => {
                setAdmins(res.data);
            });
        });
    };

    return (
        <div className="pt-4">
            <h1>Admins</h1>
            <table className="table">
                <thead>
                    <tr>
                        <th style={{ width: "5%" }}></th>
                        <th style={{ width: "25%" }}>Name</th>
                        <th style={{ width: "25%" }}>Email</th>
                        <th style={{ width: "10%" }}>Phone Number</th>
                        <th style={{ width: "25%" }}></th>
                    </tr>
                </thead>
                <tbody>
                    {admins.map((user, i) => (
                        <tr key={i}>
                            <td>
                                <Avatar name={user.firstName} src={user.photo} size="50px" round={true} />
                            </td>
                            <td>
                                <div>{user.firstName}</div>
                                <small className="text-muted">{user.id}</small>
                            </td>
                            <td>
                                <div>{user.email || "-"}</div>
                            </td>
                            <td>{user.phoneNumber || "-"}</td>
                            <td>
                                <Button color="danger" outline onClick={removeAdminClaim(user.id)}>
                                    Remove Admin Claim
                                </Button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};
